// src/app/modules/Members/MembersMainPage.jsx
import React from "react";
import { Routes, Route } from "react-router-dom";
import { Members } from "./Members";
import { MemberDetails } from "./MemberDetails";
import { shallowEqual, useSelector } from "react-redux";

export function MembersMainPage() {
  
  const { org } = useSelector(
    (state) => ({
      org: state.auth.organization,
    }),
    shallowEqual
  );

  return (
    <Routes>
      {/* Main members list */}
      <Route path="/" element={<Members />} />
      
      {/* Member details page */}
      <Route 
        path="/view/:id" 
        element={<MemberDetails organizationId={org?.organization_id} />} 
      />
    </Routes>
  );
}